import React, { useContext } from 'react'
import { AppContext } from '../context/AppContext';

const LocationSlideOne = () => {

    const {retrive} = useContext(AppContext);
    const {slideIndex} = useContext(AppContext);

    const [ retreivealMarker ] = retrive;

    const [ indexSlideValue , setIndexSlideValue ] = slideIndex;


  return (
    <div>
        <div className="location_info">

<div className="main_image slide_main_div"  >



    <div className="mt-4 content-main-image">
    <div className="d-flex-c f-sv f-wrap">
        <button className="btn_status_location"> خدماتنا </button>
        <h1 className='location_slidetwo_headline' >   {retreivealMarker.name}  </h1>
        </div>
        
     <div className="mt-4 services_location_icons d-flex-c f-sv">

        <div className="single_serv_icon" onClick={() => setIndexSlideValue(2) } >
            <img src="/images/icons/photographer.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1">  استكشاف المكان </h1>
        </div>

        <div className="single_serv_icon" onClick={() => setIndexSlideValue(5) } >
            <img src="/images/icons/hotel-icon.png" className='icon_small' alt="" />
            <h1 className=" headline_info mt-1">  حجز بكج </h1>
        </div>

     </div>
   

    </div>
</div>


</div>
    </div>
  )
}

export default LocationSlideOne